import React from 'react'
import { Icon } from 'semantic-ui-react'

import moment from 'moment'

const VocationalProfDevelopment = ({
  isViewAsTeacher,
  developments,
  showEditProfDev,
  setQTarget,
  setQType,
  toogleShowConfirmModal,
}) => {
  return developments && developments.length > 0 ? (
    <ul className='container p-0'>
      {developments
        .sort((a, b) => {
          let dateA = moment(a.end_date, 'MM/YYYY')
          let dateB = moment(b.end_date, 'MM/YYYY')
          return dateB.diff(dateA)
        })
        .map((q, index, array) => {
          return (
            <li key={q._id} className='p-0'>
              <div className='row'>
                <div className='col-8'>
                  <p className='mb-2 profile-qualification-title text-left'>
                    {q.activity}
                  </p>
                  <p className='mb-2 profile-qualification-place text-left'>
                    {q.focus_event}
                  </p>
                  <p className='profile-qualification-place text-left'>
                    {q.location}{q.institution_city ? `, ${q.institution_city}` : ''}{q.institution_country ? `, ${q.institution_country}` : ''}
                  </p>
                </div>

                <div className='col-4'>
                  <p className='mt-0 mb-0 profile-qualification-title text-right'>
                    {q.end_date !== 'Present' ? (
                      // q.end_date.length === 7 ? (
                      moment(q.end_date, 'MM/YYYY').format('MMM YYYY')
                      // ) : (
                      //   'NaN'
                      // )
                    ) : (
                      <p className='mt-0 mb-0 profile-qualification-title text-right'>
                        Currently Enrolled
                      </p>
                    )}
                  </p>

                  {isViewAsTeacher ? (
                    <p className='mb-0 profile-qualification-title text-right mt-2'>
                      <Icon
                        name='pencil'
                        circular
                        inverted
                        color='#3bb4d8'
                        onClick={() => showEditProfDev(q)}
                        className='qualification-container-update-icon'
                      >
                        {' '}
                      </Icon>
                      <Icon
                        name='trash'
                        circular
                        inverted
                        color='grey'
                        onClick={() => {
                          setQTarget(q)
                          setQType('VPD')
                          toogleShowConfirmModal(true)
                        }}
                        className='qualification-container-update-icon'
                      >
                        {' '}
                      </Icon>
                    </p>
                  ) : null}
                </div>
                {index !== array.length - 1 && (
                  <div className='col-12'>
                    <hr className='qualification-line-1 my-3'></hr>
                  </div>
                )}
              </div>
            </li>
          )
        })}
    </ul>
  ) : null
}

export default VocationalProfDevelopment
